import { getEsignatureIntegrations } from '~/common/constants/integrations';
import logos from '~/components/Shared/ProviderLogo/logos';
import { EsignatureType } from '~/enums/EsignatureType';

export const getIntegrationDetails = (provideName?: EsignatureType) => {
  if (!provideName) return null;

  const esignatureIntegrations = getEsignatureIntegrations();
  const integrationDetails = esignatureIntegrations[provideName];
  const logoSrc = logos[provideName];
  return { ...integrationDetails, logoSrc };
};

/**
 * Determines the status type of an eSignature integration based on its active state, error state, and whether it is currently active.
 *
 * @param {boolean} hasActiveIntegration - Indicates if there is an active eSignature integration.
 * @param {boolean} isActive - Indicates if the eSignature integration is currently active.
 * @param {boolean} hasError - Indicates if there is an error with the eSignature integration.
 * @returns {string | null} Returns 'warning' if there is an active integration that is not active, 'error' if the integration is active but has an error, or null if none of these conditions are met.
 */
export const getIntegrationStatusType = (
  isActive: boolean,
  isDisabled: boolean,
  hasError: boolean,
) => {
  if (isDisabled) {
    return 'warning';
  } else if (hasError) {
    return 'error';
  }
  return null;
};

export type IntegrationMessageType = ReturnType<
  typeof getIntegrationStatusType
>;
